import PropTypes from 'prop-types'

import chartingPromoBackground from 'assets/charting-promo-background.svg'
import theme from 'theme'

const AnnouncementBannerWrapper = ({ children, blank, ...props }) => {
  return (
    <div
      css={{
        background: blank
          ? theme.colors.gray[0]
          : `url(${chartingPromoBackground}) no-repeat top right,linear-gradient(250deg,#196472 0%,#164175 100%)`,
        border: blank ? theme.border.base : 'none',
        borderRadius: theme.borderRadius[0],
        padding: theme.space[4],
        gap: theme.space[7]
      }}
      {...props}
    >
      {children}
    </div>
  )
}

AnnouncementBannerWrapper.propTypes = {
  children: PropTypes.node,
  blank: PropTypes.bool
}

export default AnnouncementBannerWrapper
